import React, { useMemo, useState } from 'react';
import useRosterFileHistoryEvents from '../../../rosterTools/hooks/useRosterFileHistoryEvents';
import {
  buildEventNameBarsForYearFilter,
  EVENTS_YEAR_FILTER_ALL,
  getAvailableActivityYears,
} from '../../../rosterTools/statistics/rosterHistoryChartData';
import DashboardEventsByNameBars from './DashboardEventsByNameBars';

export default function DashboardEventsByNameChart({
  handleId,
  scope = 'cluster',
  enabled = false,
  rosterDatasetRevision = 0,
  title = null,
}) {
  const { eventsLoading, eventsError, visibleEvents } = useRosterFileHistoryEvents({
    handleId,
    scope,
    enabled,
    rosterDatasetRevision,
  });

  const availableYears = useMemo(
    () => getAvailableActivityYears(visibleEvents),
    [visibleEvents],
  );

  const [yearFilter, setYearFilter] = useState(EVENTS_YEAR_FILTER_ALL);

  const eventNameBars = useMemo(
    () => buildEventNameBarsForYearFilter(visibleEvents, yearFilter),
    [visibleEvents, yearFilter],
  );

  const selectId = `dashboard-events-year-${handleId ?? 'x'}`;

  const toolbar = (
    <div className="member-dashboard__chart-toolbar">
      <label
        htmlFor={selectId}
        className="member-dashboard__chart-toolbar-label"
      >
        Year
      </label>
      <select
        id={selectId}
        className="member-dashboard__chart-year-select"
        value={yearFilter === EVENTS_YEAR_FILTER_ALL ? EVENTS_YEAR_FILTER_ALL : String(yearFilter)}
        onChange={(e) => {
          const v = e.target.value;
          setYearFilter(v === EVENTS_YEAR_FILTER_ALL ? EVENTS_YEAR_FILTER_ALL : Number(v));
        }}
        disabled={eventsLoading}
        aria-label="Events by name year"
      >
        <option value={EVENTS_YEAR_FILTER_ALL}>All</option>
        {availableYears.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );

  const body = eventsLoading ? (
    <p className="member-dashboard__panel-placeholder">Loading…</p>
  ) : eventsError ? (
    <p className="member-dashboard__panel-placeholder">{eventsError}</p>
  ) : eventNameBars.labels.length === 0 ? (
    <p className="member-dashboard__panel-placeholder">No events.</p>
  ) : (
    <DashboardEventsByNameBars
      labels={eventNameBars.labels}
      values={eventNameBars.values}
    />
  );

  if (title) {
    return (
      <>
        <div
          className="display-none"
          data-resource="private.navbar.personalhub.events"
          data-action="read"
          data-route="/api/user/roster-file-history-events"
          data-description="Personal hub — events by name chart"
        />

        <div className="member-dashboard__panel-card-head member-dashboard__events-card-head">
          <h2 className="member-dashboard__panel-title">{title}</h2>
          {toolbar}
        </div>

        <div className="member-dashboard__panel-card-body">{body}</div>
      </>
    );
  }

  return (
    <>
      <div
        className="display-none"
        data-resource="private.navbar.personalhub.events"
        data-action="read"
        data-route="/api/user/roster-file-history-events"
        data-description="Personal hub — events by name chart"
      />

      {toolbar}
      {body}
    </>
  );
}
